// HOOKS
import { useMutation } from "@apollo/client";
import { useState, useCallback, useEffect } from "react";
// GRAPHQL
import { UPDATE_PRODUCT } from "../../graphql/mutations/products/products.mutations";

const useUpdateProduct = () => {
  const [timedUpdate, setTimedUpdate] = useState(null);
  const [updateProductMutation, { loading, error, data }] =
    useMutation(UPDATE_PRODUCT);

  const updateProduct = useCallback(
    async (product) => {
      if (timedUpdate) clearTimeout(timedUpdate);

      const timeout = setTimeout(async () => {
        // Remove __typename from input
        const filteredProduct = Object.entries(product)
          .filter(([key]) => key !== "__typename")
          .reduce((obj, [key, value]) => {
            obj[key] = value;
            return obj;
          }, {});
        // Split tags by comma and trim white space
        if (filteredProduct.tags) {
          filteredProduct.tags = filteredProduct.tags
            .split(",")
            .map((tag) => tag.trim());
        }

        updateProductMutation({
          variables: { product: { ...filteredProduct } },
        }).catch((apolloError) => {
          // If needed, handle Apollo Client errors specifically here
          console.error(`Apollo error updating asset: ${apolloError.message}`);
          alert(`Apollo error updating asset: ${apolloError.message}`);
        });
      }, 800);

      setTimedUpdate(timeout);
    },
    [updateProductMutation, timedUpdate]
  );

  // Ensure to clear the timeout on component unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      if (timedUpdate) clearTimeout(timedUpdate);
    };
  }, [timedUpdate]);

  return { updateProduct, loading, error, data };
};

export default useUpdateProduct;
